import $ from 'jquery';
import Rails from '@rails/ujs';

$(document).on('confirmation', '[data-remodal-id]', function () {
    const $form = $($(this).find('form'));
    if ($form.data('remote')) {
        Rails.fire($form[0], 'submit');
    } else {
        $form.submit();
    }
});
$(document).on('opened', '.remodal', function () {
    $(this).find('.focus').eq(0).focus();
});
